import { formatEventTimestampSafe } from '@klareospace/pharos-lib-front-utils';
import { resolveDriverName } from '@klareospace/pharos-lib-utils';
import { TASK_STATUS, type Task } from '@klareospace/pharos-lib-types';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface FailureAttribution {
  readonly driverName?: string;
  readonly timestamp?: string;
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

/** True when the task ended in FAILED status. */
export function isFailedTask(task: Task): boolean {
  return task.status === TASK_STATUS.FAILED;
}

/** True when the task ended in CANCELLED status. */
export function isCancelledTask(task: Task): boolean {
  return task.status === TASK_STATUS.CANCELLED;
}

/** True when `statusReasonMessage` holds a non-empty comment, regardless of task status. */
export function hasStatusReasonComment(task: Task): boolean {
  return Boolean(task.statusReasonMessage?.trim());
}

/** True when the task failed with a non-empty driver-entered comment (any failure reason). */
export function hasFailureComment(task: Task): boolean {
  return isFailedTask(task) && hasStatusReasonComment(task);
}

/** Resolves the driver name and formatted completion timestamp, omitting either when missing. */
export function resolveFailureAttribution(task: Task): FailureAttribution {
  return {
    driverName: resolveDriverName(task.driver),
    timestamp: formatEventTimestampSafe(task.completedAt),
  };
}
